module.exports = __webpack_public_path__ + "img/logo_annex_col_color.40749f5f.png";